import type { RunUnlocksDto } from '@rw/shared';
import { Link } from 'react-router';
import { useT } from '../../i18n';
import { BadgeMedal } from './BadgeMedal';
import { RANK_STYLE, badgeTierName, rankName } from './achievements';

/** On the owner's run: the rank reached and badges unlocked by this run. */
export function UnlockedCard({
  unlocked,
  fresh,
}: {
  unlocked: RunUnlocksDto | null | undefined;
  fresh: boolean;
}) {
  const t = useT();
  if (!unlocked || (!unlocked.rank && !unlocked.badges.length)) return null;
  const rank = unlocked.rank ? RANK_STYLE[unlocked.rank] : null;
  return (
    <Link
      to="/badges"
      className={`mt-4 block rounded-3xl border border-gold/50 bg-gold/10 p-4 text-center ${fresh ? 'animate-capture' : ''}`}
      data-testid="run-unlocked"
    >
      {unlocked.rank && rank ? (
        <div data-testid="run-rank-up">
          <span
            className="hex-clip mx-auto grid size-16 place-items-center text-3xl"
            style={{ background: rank.bg }}
          >
            {rank.icon}
          </span>
          <div className="mt-2 font-display text-lg font-bold uppercase tracking-widest">
            {t('New rank: {rank}', { rank: rankName(unlocked.rank) })}
          </div>
        </div>
      ) : null}
      {unlocked.badges.length ? (
        <div className={unlocked.rank ? 'mt-4' : ''}>
          <div className="font-display text-lg font-bold uppercase tracking-widest">
            {t(unlocked.badges.length === 1 ? 'Badge unlocked' : 'Badges unlocked')}
          </div>
          <div className="mt-2 flex flex-wrap justify-center gap-3">
            {unlocked.badges.map((b) => (
              <div
                key={b.id}
                className="flex w-20 flex-col items-center"
                data-testid={`unlocked-${b.id}`}
              >
                <BadgeMedal id={b.id} tier={b.tier} size={56} />
                <span className="mt-1 text-xs font-semibold leading-tight">
                  {badgeTierName(b.id, b.tier)}
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </Link>
  );
}
